import React from 'react';
import { AppBar, Toolbar, IconButton, Badge, Menu, Item, Typography } from '@material-ui/core';
import { ShoppingCart } from '@material-ui/icons';
import logo from "../../assets/commerce.png";
import useStyles from "./styles";
import { Link, useLocation } from "react-router-dom";

const Navbar = ({ totalItems }) => {
    const classes = useStyles();
    const location = useLocation();

    return (
        <>
                <AppBar position="fixed" className={classes.appBar} color="inherit">
                    <Toolbar>
                        <Typography component={Link} to="/" style={{ textDecoration: 'none' }} variant="h6" className={classes.appBar} color="inherit">
                            <img src={logo} alt="Name of shop" height="25px" className={classes.image} />
                            Shop name
                        </Typography>
                        <div className={classes.grow} />
                        {location.pathname === '/' && (
                        <div className={classes.button}>
                            <IconButton component={Link} to="/cart" aria-lable="Show cart items" color="inherit">
                                <Badge badgeContent={totalItems} color="secondary">
                                    <ShoppingCart />
                                </Badge>
                            </IconButton>
                        </div> )}
                    </Toolbar>
                </AppBar>
        </>
    )
};

export default Navbar;
